import ReactIcon from '@ant-design/icons-react';
export function setTwoToneColor(primaryColor) {
    return ReactIcon.setTwoToneColors({
        primaryColor: primaryColor
    });
}
export function getTwoToneColor() {
    var colors = ReactIcon.getTwoToneColors();
    return colors.primaryColor;
}


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.9.3@antd/es/icon/twoTonePrimaryColor.js
// module id = 519
// module chunks = 0